export enum EmersonViewProductEntryPoint {
  PRODUCT_CARD = "ProductCard",
  SIMILAR_PRODUCT_CARD = "Similar_ProductCard",
  ORDER_DETAILS = "OrderDetails",
  REORDER_PRODUCTS = "ReorderProducts",
  CHECKOUT = "Checkout",
  QUICK_VIEW = "QuickView",
  QUICK_ORDER = "QuickOrder",
}

export enum EmersonCheckoutAddToCartEntryPoint {
  PRODUCT_CARD = "ProductCard",
  SIMILAR_PRODUCT_CARD = "Similar_ProductCard",
  PRODUCT_DETAILS_PAGE = "ProductDetailsPage",
  ORDER_DETAILS = "OrderDetails",
  REORDER_PRODUCTS = "ReorderProducts",
  BACKORDER_PAGE = "BackorderPage",
  BACKORDER_PAGE_SIMILAR_PRODUCTS = "BackorderPage_SimilarProducts",
  QUICK_ORDER = "QuickOrder",
  QUICK_VIEW = "QuickView",
}

export enum EmersonCheckoutStartEntryPoint {
  CART_DROPDOWN_HEADER = "TopNav_CartDropdown",
  CATALOG_PRODUCTCARD_VIEWCART = "Catalog_ProductCard_ViewCart",
  CATALOG_PRODUCTPAGE_VIEWCART = "Catalog_ProductDetailPage_ViewCart",
  REORDERPAGE_LINEITEM_VIEWCART = "ReorderPage_LineItem_ViewCart",
  ORDERDETAILPAGE_LINEITEM_VIEWCART = "OrderDetailsPage_LineItem_ViewCart",
  PRODUCTPAGE_SIMILAR_PRODUCTCARD_VIEWCART = "ProductDetailPage_Similar_ProductCard_ViewCart",
  QUICK_ORDER = "QuickOrder",
  QUICK_VIEW = "QuickView",
}

export enum EmersonSearchApplyFilterEntryPoint {
  CATALOG_PAGE = "CatalogPage",
  SHOP_MENU = "ShopMenu",
  BRANDS_MENU = "BrandsMenu",
  ALL_BRANDS_PAGE = "AllBrandsPage",
}

export enum CancelBackorderEntryPoint {
  BACKORDER_PAGE = "BackorderPage",
}

export enum EmersonBrandAgreementEntryPoint {
  PRODUCT_CARD = "ProductCard",
  PRODUCT_DETAILS_PAGE = "ProductDetailsPage",
  ORDER_DETAILS = "OrderDetails",
  BRAND_AGREEMENTS_PAGE = "BrandAgreementsPage",
  REORDER_PRODUCTS = "ReorderProducts",
}

type EmersonEntryPoint =
  | EmersonViewProductEntryPoint
  | EmersonCheckoutAddToCartEntryPoint
  | EmersonCheckoutStartEntryPoint
  | EmersonSearchApplyFilterEntryPoint
  | CancelBackorderEntryPoint
  | EmersonBrandAgreementEntryPoint;

export type { EmersonEntryPoint };
